import React, { useEffect, useRef, useState } from 'react'
import { SortDesc } from 'lucide-react'

export function SortFilter({ filters, setFilters }) {
  const [isOpen, setIsOpen] = useState(false)
  const sortFilterRef = useRef(null)

  // Custom logic to handle outside clicks
  useEffect(() => {
    function handleClickOutside(event) {
      if (sortFilterRef.current && !sortFilterRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const handleSelect = (option) => {
    setFilters((prevFilters) => ({ ...prevFilters, sort: option }))
    setIsOpen(false)
  }

  return (
    <div className="relative border-l border-[#e4e4e4] h-10 flex justify-center items-center min-w-[140px] flex-shrink-0" ref={sortFilterRef}>
      <button className="w-full h-full px-3 flex justify-between items-center gap-2 whitespace-nowrap" onClick={() => setIsOpen(!isOpen)}>
        <div className="flex items-center gap-2">
          <SortDesc className="h-4 w-4 text-[#3f424a]" />
          <p className="text-[#3f424a] text-base font-semibold font-['Manrope'] leading-tight">
            {filters.sort === 'popular' ? 'Popular' : 'Recent'}
          </p>
        </div>
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_3498_24364)">
            <circle cx="10.4925" cy="10.2835" r="7.27964" fill="#EBEBEB" />
            <path
              d="M12.9195 9.47656L10.493 11.9031L8.06641 9.47656"
              stroke="#40424A"
              strokeWidth="1.3866"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3498_24364">
              <rect width="19.4124" height="19.4124" fill="white" transform="translate(0.787109 0.578125)" />
            </clipPath>
          </defs>
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 z-50 mt-1 w-[140px] overflow-hidden rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 pointer-events-auto">
          <div className="py-1">
            <div
              className={`flex items-center px-4 py-2 cursor-pointer ${filters.sort === 'popular' ? 'bg-[#f5f5f5]' : 'hover:bg-[#f5f5f5]'}`}
              onClick={() => handleSelect('popular')}
            >
              <span className={`ml-2 ${filters.sort === 'popular' ? 'text-[#FF4A8E] font-semibold' : 'text-gray-700'}`}>
                Popular
              </span>
            </div>
            <div
              className={`flex items-center px-4 py-2 cursor-pointer ${filters.sort === 'recent' ? 'bg-[#f5f5f5]' : 'hover:bg-[#f5f5f5]'}`}
              onClick={() => handleSelect('recent')}
            >
              <span className={`ml-2 ${filters.sort === 'recent' ? 'text-[#FF4A8E] font-semibold' : 'text-gray-700'}`}>
                Recent
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
} 